import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IQueryParamDrivenDrawerContentProvider } from '../components/query-param-driver-drawer/IQueryParamDrivenDrawerContentProvider';
import { QueryParamDrivenDrawerHelper } from '../components/query-param-driver-drawer/QueryParamDrivenDrawerHelper';
import { StructuredRecordEditorDrawer } from './structured-records/StructuredRecordEditorDrawer';
import { AllergyDescriptor } from './AllergyDescriptor';
import { AllergyFormState } from './AllergyFormState';

interface IAllergyEditorDrawerProps {
    id: string;
}

export class AllergyEditorDrawer implements IQueryParamDrivenDrawerContentProvider<IAllergyEditorDrawerProps> {
    static inject = () => [QueryParamDrivenDrawerHelper];
    constructor(private drawerHelper: QueryParamDrivenDrawerHelper<IAllergyEditorDrawerProps>){}

    mode = 'edit-allergy';

    Component = AllergyEditorDrawerView;

    open = (props: IAllergyEditorDrawerProps) => {
        this.drawerHelper.open({ mode: this.mode, ...props });
    };

    buildQueryParams = (props: IAllergyEditorDrawerProps) => {
        return this.drawerHelper.buildQueryParams({ mode: this.mode, id: props.id });
    };
}

const AllergyEditorDrawerView: React.FC<IAllergyEditorDrawerProps> = ({ id }) => {
    const descriptor = useInstance(AllergyDescriptor);
    const formState = useInstance(AllergyFormState);

    return (
        <StructuredRecordEditorDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
